<div class="page-title-area item-bg3">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>{{service.serviceName}}</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Services Details</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-overview">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="services-details-desc" [outerHTML]="service.serviceDescription" >
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="image-sliders owl-carousel owl-theme">
                        <div class="services-details-image">
                            <img src="{{environment.ImageApiPath +'/'+ this.service?.attachment?.name}}" alt="{{service?.serviceName}}" >
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
